import { Fragment, useState } from 'react'
import { Disclosure, Transition } from '@headlessui/react'
import { Bars3Icon, ChevronDownIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { ASSETS_URL } from '../utils/constants'

const logo = ASSETS_URL + 'totalsolar-wg.png'
const logo2 = ASSETS_URL + 'totalsolar_logo_lite.png'

const navigation = [
  { name: 'Home', href: '/' },
  //{ name: 'About', href: '/about', subNav: [ {name: 'Company', href: '/about'}, {name: 'Team', href: '/team'} ] },
  { name: 'About', href: '/about'},
  { name: 'Services', href: '/services'},
  { name: 'Products', href: '/products'},
  { name: 'Projects', href: '/projects'},
  // { name: 'Updates', href: '/updates'},
  { name: 'Contact Us', href: '/contact'},
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Navbar2() {

  const [subNavList, setSubNavList] = useState([]);

  return <div className='w-full fixed top-0 z-[100]'>
  
    <Disclosure as="nav" className="bg-[#212121] w-full flex justify-center drop-shadow-md">
      {({ open }) => (
        <div className='w-[80%]'>
        
          <div className="mx-auto">
            <div className="relative flex items-center justify-between">
              <div className="absolute inset-y-0 right-0 flex items-center lg:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-start sm:items-stretch sm:justify-between">
                <div className="flex flex-shrink-1 items-center py-2">
                  <Link to={'/'}><img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="w-[60px] h-[60px]" src={logo2} /></Link>
                </div>
                <div className="hidden lg:ml-6 lg:flex items-center">
                  <div className="flex h-full items-center justify-center">
                    {navigation.map((item, index) => {
                      
                      return (item.subNav) ?
                        <div key={item.name}
                              className={classNames(
                                'btn font-[Montserrat] nav-item px-6 py-2 text-sm font-bold whitespace-nowrap h-full flex items-center text-white hover:text-[#4CB117] hover:cursor-pointer hover:border-b-[2px] hover:border-[#4CB117]'
                              )}
                              onClick={()=>{
                                if(subNavList.length == 0) {
                                  setSubNavList([...item.subNav])
                                } else {
                                  setSubNavList([])
                                }
                              }}
                              onMouseEnter={() => {
                                if(subNavList.length == 0) {
                                  setSubNavList([...item.subNav])
                                }
                              }}
                              onMouseLeave={(e)=>{
                                let subNavElement = document.getElementById('subNav')
                                if(subNavList.length > 0 && (e.relatedTarget.nodeType !== 1 || (e.relatedTarget.nodeType === 1 && !subNavElement.contains?.(e.relatedTarget)))) {
                                  setSubNavList([])
                                }
                              }}
                        ><span><span><span className='flex items-center'>{item.name} <ChevronDownIcon className=' ml-1 h-3 w-3 '/></span></span></span></div>:
                        <Link
                          key={item.name}
                          to={item.href}
                          className={classNames(
                            'btn font-[Montserrat] font-bold px-6 py-2 text-sm whitespace-nowrap h-full flex items-center text-white hover:text-[#4CB117] hover:border-b-[2px] hover:border-[#4CB117]'
                          )}>
                          <span><span><span>{item.name}</span></span></span>
                        </Link>
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Disclosure.Panel className="lg:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
            {navigation.map((item) => (
              (item.subNav) ?
                <Disclosure key={item.name}>
                  {
                    ({isOpen}) => <>
                      <Disclosure.Button className={classNames(
                                item.current ? 'bg-gray-900 text-white' : 'text-[#212121] hover:bg-[#fdcb0a] hover:text-white',
                                'block rounded-md px-3 py-2 text-base font-medium flex items-center w-full justify-center'
                            )}>
                        {item.name} <ChevronDownIcon className='ml-1 h-3 w-3'/>
                      </Disclosure.Button>
                      <Transition as='div'
                                  show={isOpen}
                                  enter="transform transition duration-[200ms] ease-in"
                                  enterFrom="opacity-0"
                                  enterTo="opacity-100"
                                  leave="transform duration-[200ms] transition ease-in"
                                  leaveFrom="opacity-100 "
                                  leaveTo="opacity-0">
                        <Disclosure.Panel>
                        {
                          item.subNav.map((subNav) => <>
                            <Disclosure.Button
                              key={subNav.name}
                              as="a"
                              href={subNav.href}
                              className={classNames(
                                  subNav.current ? 'bg-gray-900 text-white' : 'text-[#212121] hover:bg-[#fdcb0a] hover:text-white hover:border-b-[2px] hover:border-[#4CB117]',
                                  'block rounded-md px-3 py-2 text-base font-medium'
                              )}
                              
                              >
                              {subNav.name}
                            </Disclosure.Button>
                          </>)
                        }
                        </Disclosure.Panel>
                      </Transition>
                      
                    </>
                  }
                  
                </Disclosure>
                :
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                      'text-white hover:bg-gray-700 hover:text-[#4CB117]',
                      'block rounded-md px-3 py-2 text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                  >
                  {item.name}
                </Disclosure.Button>
            ))}
            </div>
        </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
    <Transition
          as={Fragment}
          show={subNavList.length > 0}
          enter="transform transition duration-[200ms] ease-in"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transform duration-[200ms] transition"
          leaveFrom="opacity-100  translate-y-0"
          leaveTo="opacity-0 -translate-y-[50px]"
        >
      <div id='subNav' 
          onMouseLeave={(e)=>{
              if(e.relatedTarget.classList && !e.relatedTarget.classList.contains('nav-item'))
              setSubNavList([])
          }}
          className='w-full py-5 bg-[#212121] relative flex justify-end pr-[28rem]' >
      {
        subNavList.map((subNav) => {
          return <Link key={subNav.name} 
                      className='btn px-6 py-2 font-[Montserrat] font-bold text-sm text-white bg-[#212121] hover:text-[#4CB117] hover:border-b-[2px] hover:border-[#4CB117]'
                      to={subNav.href}><span><span><span>{subNav.name}</span></span></span></Link>
        })
      }
      </div>
    </Transition>
    
  </div>
}